var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.02 25.9413C206.02 38.0699 196.188 47.902 184.059 47.902C171.93 47.902 162.098 38.0699 162.098 25.9413C162.098 13.8126 171.93 3.98047 184.059 3.98047C196.188 3.98047 206.02 13.8126 206.02 25.9413Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.902 25.9413C47.902 38.0699 38.0699 47.902 25.9413 47.902C13.8126 47.902 3.98047 38.0699 3.98047 25.9413C3.98047 13.8126 13.8126 3.98047 25.9413 3.98047C38.0699 3.98047 47.902 13.8126 47.902 25.9413Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.961 25.9413C126.961 38.0699 117.129 47.902 105 47.902C92.8715 47.902 83.0393 38.0699 83.0393 25.9413C83.0393 13.8126 92.8715 3.98047 105 3.98047C117.129 3.98047 126.961 13.8126 126.961 25.9413Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.02 105C206.02 117.129 196.188 126.961 184.059 126.961C171.93 126.961 162.098 117.129 162.098 105C162.098 92.8715 171.93 83.0393 184.059 83.0393C196.188 83.0393 206.02 92.8715 206.02 105Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.902 105C47.902 117.129 38.0699 126.961 25.9413 126.961C13.8126 126.961 3.98047 117.129 3.98047 105C3.98047 92.8715 13.8126 83.0393 25.9413 83.0393C38.0699 83.0393 47.902 92.8715 47.902 105Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.961 105C126.961 117.129 117.129 126.961 105 126.961C92.8715 126.961 83.0393 117.129 83.0393 105C83.0393 92.8715 92.8715 83.0393 105 83.0393C117.129 83.0393 126.961 92.8715 126.961 105Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.02 184.059C206.02 196.188 196.188 206.02 184.059 206.02C171.93 206.02 162.098 196.188 162.098 184.059C162.098 171.93 171.93 162.098 184.059 162.098C196.188 162.098 206.02 171.93 206.02 184.059Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.902 184.059C47.902 196.188 38.0699 206.02 25.9413 206.02C13.8126 206.02 3.98047 196.188 3.98047 184.059C3.98047 171.93 13.8126 162.098 25.9413 162.098C38.0699 162.098 47.902 171.93 47.902 184.059Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.961 184.059C126.961 196.188 117.129 206.02 105 206.02C92.8715 206.02 83.0393 196.188 83.0393 184.059C83.0393 171.93 92.8715 162.098 105 162.098C117.129 162.098 126.961 171.93 126.961 184.059Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/Vector_8.ddeafa1f5b195c9b8e9a27ba7f2c94a9.svg";
export { ForwardRef as ReactComponent };